import type { Scene, SceneFolder } from "../types";

export function visibleScenes(scenes: Scene[], campaignId: string, query = "", includeArchived = false): Scene[] {
  const needle = query.trim().toLocaleLowerCase();
  return scenes.filter((scene) => scene.campaignId === campaignId && (includeArchived || !scene.archived) && (!needle || scene.name.toLocaleLowerCase().includes(needle)));
}

export function sceneFolderGroups(scenes: Scene[], folders: SceneFolder[]): Array<{ folder?: SceneFolder; scenes: Scene[] }> {
  const result: Array<{ folder?: SceneFolder; scenes: Scene[] }> = folders.map((folder) => ({ folder, scenes: scenes.filter((scene) => scene.folderId === folder.id) })).filter((group) => group.scenes.length);
  const unfiled = scenes.filter((scene) => !folders.some((folder) => folder.id === scene.folderId));
  if (unfiled.length) result.unshift({ scenes: unfiled });
  return result;
}
